export default __webpack_public_path__ + "static/media/banner.a5551b10.jpg";